import { Api } from './api';

const extractFavoriteList = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data?.data)) return payload.data.data;
  if (Array.isArray(payload?.data)) return payload.data;
  return [];
};

const resolveFavoriteEntryId = (entry) =>
  entry?.favoritesId || entry?.favoriteId || entry?.id || null;

const resolveProductIdFromEntry = (entry) => {
  if (!entry) return null;
  if (entry.product) {
    return (
      entry.product.productId ||
      entry.product.id ||
      entry.productId ||
      entry.id ||
      null
    );
  }
  return entry.productId || entry.id || null;
};

const findFavoriteIdForProduct = (favorites, productId) => {
  if (!productId) return null;
  const normalizedId = String(productId);
  const match = favorites.find((entry) => {
    const entryProductId = resolveProductIdFromEntry(entry);
    return entryProductId && String(entryProductId) === normalizedId;
  });
  return resolveFavoriteEntryId(match);
};

const loadFavoriteIdForProduct = async (customerId, productId) => {
  if (!customerId || !productId) return null;
  try {
    const response = await Api.fetchFavorites(customerId);
    const list = extractFavoriteList(response);
    return findFavoriteIdForProduct(list, productId);
  } catch {
    return null;
  }
};

const resolveFavoriteIdFromProduct = (product) =>
  product?.favoriteId || product?.favoritesId || product?.favoriteEntryId || null;

const resolveFavoriteIdFromResponse = (payload) =>
  payload?.data?.favoritesId ||
  payload?.data?.id ||
  payload?.favoritesId ||
  payload?.id ||
  null;

export const toggleProductFavorite = async ({ product, customerId }) => {
  if (!product) {
    throw new Error('Product is required to toggle favorite state.');
  }
  if (!customerId) {
    throw new Error('Customer id is required to toggle favorite state.');
  }
  const productId = product.productId || product.id;
  if (!productId) {
    throw new Error('Product id is required to toggle favorite state.');
  }

  if (product.favorite) {
    let favoriteId = resolveFavoriteIdFromProduct(product);
    if (!favoriteId) {
      favoriteId = await loadFavoriteIdForProduct(customerId, productId);
    }
    if (favoriteId) {
      await Api.deleteFavorite(favoriteId);
    }
    return { favorite: false, favoriteId: null };
  }

  const response = await Api.addFavorite({
    customerId,
    productId,
    businessId: product.businessId || product.restaurant_id || null,
  });
  let favoriteId = resolveFavoriteIdFromResponse(response);
  if (!favoriteId) {
    favoriteId = await loadFavoriteIdForProduct(customerId, productId);
  }
  return { favorite: true, favoriteId };
};

export default toggleProductFavorite;
